import * as axios from 'axios';

const { VUE_APP_API_URL } = process.env || {};
export const getRegionalMarkets = (token) => axios.get(`${VUE_APP_API_URL}/api/v1/admin/regionalMarkets`, {
  headers: {
    Authorization: `Bearer ${token}`, // send the access token through the 'Authorization' header
  },
});

export const getRegionalMarket = (token, regionalMarketId) => axios.get(`${VUE_APP_API_URL}/api/v1/admin/regionalMarkets/${regionalMarketId}`, {
  headers: {
    Authorization: `Bearer ${token}`, // send the access token through the 'Authorization' header
  },
});
export const createRegionalMarket = (token, body) => axios.post(`${VUE_APP_API_URL}/api/v1/admin/regionalMarkets`, body, {
  headers: {
    Authorization: `Bearer ${token}`, // send the access token through the 'Authorization' header
  },
});
export const updateRegionalMarket = (token, id, body) => axios.put(`${VUE_APP_API_URL}/api/v1/admin/regionalMarkets/${id}`, body, {
  headers: {
    Authorization: `Bearer ${token}`, // send the access token through the 'Authorization' header
  },
});
export const deleteRegionalMarket = (token, id) => axios.delete(`${VUE_APP_API_URL}/api/v1/admin/regionalMarkets/${id}`, {
  headers: {
    Authorization: `Bearer ${token}`, // send the access token through the 'Authorization' header
  },
});
